<ng-container *ngIf="!(heatingPanelService.isComfortMode$ | async)">
  <ng-container *ngIf="comfort$ | async | ready as feature">
    <app-program-panel
      *ngIf="feature?.properties?.active?.value"
      data-at-comfort-panel
      [program]="feature.feature | modeName"
      [active]="feature?.properties?.active?.value"
    >
      <vi-icon icon name="heating-mode-{{ feature.feature | modeName }}" [size]="20"></vi-icon>
      <ng-container message>{{ '+SCHEDULES.PROGRAM_PANEL.COMFORT_MODE' | translate }}</ng-container>
    </app-program-panel>
  </ng-container>
</ng-container>
